import { render, staticRenderFns } from "./SetSorting.vue?vue&type=template&id=4ad468b0&scoped=true"
import script from "./SetSorting.vue?vue&type=script&lang=js"
export * from "./SetSorting.vue?vue&type=script&lang=js"
import style0 from "./SetSorting.vue?vue&type=style&index=0&id=4ad468b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad468b0",
  null
  
)

export default component.exports